import get from 'lodash/get';

// Persist cookies for 24 hours
const TTL = 60 * 60 * 24;

export default (context) => {
  const { $cookies } = context;
  const query = get(context, 'route.query') || {};

  const {
    utm_source: source,
    utm_medium: medium,
    utm_campaign: campaign,
  } = query;

  if (source || medium || campaign) {
    // Reset ALL cookies whenever any UTM params are provided
    // We don't wanna mix up campaigns if we only receive some params
    $cookies.set('utm_source', source || '', { path: '/', maxAge: TTL });
    $cookies.set('utm_medium', medium || '', { path: '/', maxAge: TTL });
    $cookies.set('utm_campaign', campaign || '', { path: '/', maxAge: TTL });
  }
};
